import { apiClient } from './client';

export interface LowStockItem {
  id: number;
  productId: number;
  productName: string;
  productArticle?: string;
  warehouseId: number;
  warehouseName: string;
  quantity: number;
  unitShortName: string;
  /** Минимальный остаток из карточки товара */
  minStock: string;
}

export interface LowStockResponse {
  data: LowStockItem[];
  total: number;
}

export const lowStockApi = {
  // Товары, у которых остаток не больше минимума из карточки
  getLowStockItems: async (warehouseId?: number): Promise<LowStockResponse> => {
    const response = await apiClient.get('/low-stock', {
      params: warehouseId ? { warehouseId } : undefined
    });
    return response.data;
  },
};
